export const minUsePoint = 100;
export const minUseMileage = 100;
export const minRetentionMileage = 1000;
export const minimumDiscountedPrice = 0;
